// Rate-limit preflight server function for invoice uploads.
// Client calls this once at the start of a submit to consume one upload slot
// against the per-user + per-IP counter before uploading files directly to
// storage. Limits are conservative (10 uploads/hr per user, 30/hr per IP).

import { createServerFn } from "@tanstack/react-start";
import { getRequest } from "@tanstack/react-start/server";
import { requireStaffWhileLocked } from "@/lib/launch-lock-middleware";
import {
  enforceRateLimit,
  clientIpFromRequest,
  hashIp,
  RateLimitExceededError,
} from "@/lib/rate-limit.server";

export const checkInvoiceUploadAllowance = createServerFn({ method: "POST" })
  .middleware([requireStaffWhileLocked])
  .handler(async ({ context }) => {
    try {
      const req = getRequest();
      const ip = req ? clientIpFromRequest(req) : null;
      const ipHash = await hashIp(ip);
      await enforceRateLimit({
        bucket: "invoice_upload",
        key: context.userId,
        max: 10,
        windowSeconds: 3600,
        ip: ipHash,
        userId: context.userId,
      });
      return { ok: true as const };
    } catch (err) {
      if (err instanceof RateLimitExceededError) {
        // Return a structured result so the client can render our friendly
        // message without an ugly RPC-error toast.
        return { ok: false as const, message: err.message, resetAt: err.resetAt };
      }
      throw err;
    }
  });
